import moment from "moment";

import PLANS from "../data/plans.json";

const AUTH_KEY = "loope_auth_user";
const ONESIGNAL_INFO = "onesignal_info";
const ONESIGNAL_INFO_RESPONSE = "onesignal_info_response";

const getAuthToken = () => {
  let token = null;

  try {
    token =
      localStorage.getItem(AUTH_KEY) != null
        ? JSON.parse(localStorage.getItem(AUTH_KEY))
        : null;
  } catch (err) {
    console.log("Failed to get Auth Token", err);
    token = null;
  }

  return token;
};

const setAuthToken = (auth) => {
  try {
    if (
      auth &&
      auth.currentUser &&
      auth.currentUser.uid &&
      auth.currentUser.uid.length
    ) {
      localStorage.setItem(
        AUTH_KEY,
        JSON.stringify({
          uid: auth.currentUser.uid,
          timestamp: new Date(),
          // So we can find out if their trial has expired
          creationTime: auth.currentUser.metadata.creationTime,
        })
      );
    } else {
      localStorage.removeItem(AUTH_KEY);
    }
  } catch (err) {
    console.log("Failed to set Auth Token", err);
  }
};

// Can also be used to tell if on a mobile device for disabling the subscriptions page.
const getOneSignalInfo = () => {
  let oneSignalInfo = null;

  try {
    oneSignalInfo =
      localStorage.getItem(ONESIGNAL_INFO) != null
        ? JSON.parse(localStorage.getItem(ONESIGNAL_INFO))
        : null;
  } catch (err) {
    console.log("Failed to get OneSignal info", err);
    oneSignalInfo = null;
  }

  return oneSignalInfo;
};

const isMobile = () => !!getOneSignalInfo();

const setOneSignalInfo = (oneSignalInfo) => {
  try {
    if (oneSignalInfo) {
      localStorage.setItem(
        ONESIGNAL_INFO,
        JSON.stringify({ oneSignalInfo: oneSignalInfo, timestamp: new Date() })
      );
    } else {
      localStorage.removeItem(ONESIGNAL_INFO);
    }
  } catch (err) {
    console.log("Failed to set OneSignal info", err);
  }
};

// Can also be used to tell if on a mobile device for disabling the subscriptions page.
const getOneSignalInfoResponse = () => {
  let oneSignalInfoResponse = null;

  try {
    oneSignalInfoResponse =
      localStorage.getItem(ONESIGNAL_INFO_RESPONSE) != null
        ? JSON.parse(localStorage.getItem(ONESIGNAL_INFO_RESPONSE))
        : null;
  } catch (err) {
    console.log("Failed to get OneSignal info response", err);
    oneSignalInfoResponse = null;
  }

  return oneSignalInfoResponse;
};

const setOneSignalInfoResponse = (oneSignalInfoResponse) => {
  try {
    if (oneSignalInfoResponse) {
      localStorage.setItem(
        ONESIGNAL_INFO_RESPONSE,
        JSON.stringify({
          oneSignalInfoResponse: oneSignalInfoResponse,
          timestamp: new Date(),
        })
      );
    } else {
      localStorage.removeItem(ONESIGNAL_INFO_RESPONSE);
    }
  } catch (err) {
    console.log("Failed to set OneSignal info response", err);
  }
};

const signedUpMoreThan7DaysAgo = () =>
  moment().unix() - moment(getAuthToken().creationTime).unix() >
  7 * 24 * 60 * 60;

const accountExpired = (user) =>
  findPlanName(user) === "Trial" && signedUpMoreThan7DaysAgo();

const canAddProject = (user, projects) => {
  const hasProjectsLeft = () => {
    let planName = "Basic";
    if (user.planId) {
      planName = getPlanName(user.planId);
    }

    if (planName === "Premier" || !signedUpMoreThan7DaysAgo()) return true;

    var i = 0;
    projects.map(function (project) {
      if (project.role === "owner") {
        i += 1;
      }
    });

    if (planName === "Single" || planName === "Basic")
      if (i >= 1) return false;
      else return true;
    else if (planName === "Standard")
      if (i >= 3) return false;
      else return true;
    else if (planName === "Premier") return true;
    else return false; // Unknown plan
  };

  if (!signedUpMoreThan7DaysAgo()) return true;
  if (!user || !user.planId) return false;

  if (user.isPremium) return true;
  else return hasProjectsLeft();
};

const findPlanName = (user) => {
  var planName = "Trial";

  if (user && user.planId) {
    planName = getPlanName(user.planId);
  } else if (user && user.isPremium) {
    // No plan name (planid) but still premium must mean they're using a trial.
    planName = "Trial";
  }

  return planName;
};

const getPlanName = (planId) => {
  const plan = PLANS.filter((plan) => !plan.disabled).find(
    (plan) => plan.planId === planId
  );
  if (plan) return plan.name;
};

const hasCollaboratorsLeft = (user, collaborators, invites) => {
  const planName = findPlanName(user);
  const acceptedCount = collaborators.length;
  const invitesCount = invites.length;
  const count = acceptedCount + invitesCount;

  // TODO make this logic use the plans.json file as source of truth
  if (planName === "Single" && count >= 5) return false;
  else if (
    (planName === "Trial" ||
      planName === "Standard" ||
      planName === "Basic" ||
      planName === "Premier") &&
    count >= 50
  )
    return false;
  else return true; // count < limit
};

// TODO do we still need all this logic or can we just use hasCollaboratorsLeft
const canAddCollaborator = (user, collaborators, invites) => {
  if (!user || accountExpired(user)) {
    return false;
  }
  if (user.isPremium) {
    return true;
  } else {
    return hasCollaboratorsLeft(user, collaborators, invites);
  }
};

export {
  accountExpired,
  canAddCollaborator,
  canAddProject,
  findPlanName,
  getPlanName,
  hasCollaboratorsLeft,
  isMobile,
  signedUpMoreThan7DaysAgo,
  getAuthToken,
  setAuthToken,
  getOneSignalInfo,
  setOneSignalInfo,
  getOneSignalInfoResponse,
  setOneSignalInfoResponse,
};



// WEBPACK FOOTER //
// ./src/helpers/Utils.js